// ILEARNModulesPage.jsx
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import CompleteImage from '../../assets/image/complete.gif';

const breakpoints = {
  phone: 480,
};

const ILEARNModulesContainer = styled.div`
  // padding: 20px;
  width: 1100px;
  margin: 0 auto;
  box-sizing: border-box;

  @media (max-width: ${breakpoints.phone}px) {
    padding: 12px;
  }
`;

const ModuleSection = styled.div`
  position: relative;
  border-radius: ${({ $isFirst, $isLast }) => {
    if ($isFirst && $isLast) return '5px';
    if ($isFirst) return '5px 5px 0 0';
    if ($isLast) return '0 0 5px 5px';
    return '0';
  }};
  overflow: hidden;
`;

const ModuleTable = styled.table`
  width: 100%;
  border: 0;
  margin: 0 auto;
  text-align: left;
  background-color: ${({ colors }) => colors.formBackground};
  padding: 20px;
  border-bottom: ${({ $isLast }) => ($isLast ? '0' : '1px solid black')};
  border-radius: ${({ $isFirst, $isLast }) => {
    if ($isFirst && $isLast) return '5px';
    if ($isFirst) return '5px 5px 0 0';
    if ($isLast) return '0 0 5px 5px';
    return '0';
  }};

  @media (max-width: ${breakpoints.phone}px) {
    display: block;
    padding: 12px;
  }
`;

const ModuleRow = styled.tr`
  @media (max-width: ${breakpoints.phone}px) {
    display: block;
    margin-bottom: 16px;
  }
`;

const ModuleHeader = styled.h2`
  margin: 0 0 10px;
  text-align: left;
  font-size: 18px;
  color: ${({ colors }) => colors.labelText};

  @media (max-width: ${breakpoints.phone}px) {
    font-size: 1.2rem;
    text-align: center;
  }
`;

const CompleteImageStyled = styled.img`
  width: 75px;
  height: 75px;
  float: left;
  margin: 0 12px 8px 0;

  @media (max-width: ${breakpoints.phone}px) {
    width: 50px;
    height: 50px;
    float: none;
    display: block;
    margin: 0 auto 8px;
  }
`;

const ModuleDescriptionCell = styled.td`
  text-align: justify;
  padding: 0 20px 0 10px;
  font-size: 12px;
  font-family: "Source Sans Pro", sans-serif;
  vertical-align: top;

  &::after {
    content: "";
    display: block;
    clear: both;
  }

  @media (max-width: ${breakpoints.phone}px) {
    display: block;
    width: 100%;
    padding: 0;
    font-size: 0.95rem;
    text-align: left;
  }
`;

const ModuleDescriptionText = styled.div`
  line-height: 1.5;
`;

const ImageCell = styled.td`
  width: 230px;
  text-align: center;
  vertical-align: top;

  @media (max-width: ${breakpoints.phone}px) {
    display: block;
    margin-top: 12px;
    width: 100%;
  }
`;

const ModuleImage = styled.img`
  width: 230px;
  height: 120px;
  max-width: 100%;
  border: 0;
  object-fit: cover;
  border-radius: 10px;
  
  @media (max-width: ${breakpoints.phone}px) {
    width: 100%;
    height: auto;
    border-radius: 5px;
  }
`;

const LockedMessage = styled.div`
  margin-top: 10px;
  font-size: 13px;
  font-weight: normal;
  color: #333;

  @media (max-width: ${breakpoints.phone}px) {
    text-align: center;
  }
`;

const UnlockButton = styled.button`
  background-color: ${({ colors }) => colors.buttonBackground};
  color:            ${({ colors }) => colors.titleText};
  border:           none;
  padding:          10px 15px;
  margin-top:       10px;
  font-size:        14px;
  font-weight:      bold;
  cursor:           pointer;
  border-radius:    5px;
  text-align:       center;

  &:hover {
    opacity: 0.9;
  }

  @media (max-width: ${breakpoints.phone}px) {
    width:       100%;
    padding:     12px 10px;
    font-size:   0.8rem;
  }
`;

const DisabledOverlay = styled.div`
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background-color: rgba(192, 192, 192, 0.7);
  z-index: 1;
  pointer-events: none;
`;

const ILEARNModulesPage = ({ colors }) => {
  const navigate = useNavigate();
  const modules = useSelector((state) => state.ilearn.modules);
  console.log(modules)
  const chapters = useSelector((state) => state.ilearn.chapters);
  const navigation_link = {
    0: '/ilearn/ab/',
    1: '/ilearn/ps/',
    2: '/ilearn/cci/',
    3: '/ilearn/cpi/',
    4: '/ilearn/cs/',
    5: '/ilearn/ip/',
    6: '/ilearn/eo/',
  };

  const isModuleLocked = (idx) => {
    const moduleIndex = Number(idx);
    if (Number.isNaN(moduleIndex) || moduleIndex === 0) return false;
    const curr = chapters?.[moduleIndex];
    const prev = chapters?.[moduleIndex - 1];
    return !(curr?.is_completed || prev?.is_completed);
  };
  console.log(modules)
  console.log(chapters)
  console.log(isModuleLocked(0))

  const currentModuleName = useMemo(() => {
    if (!modules || !modules.length) return "";
    for (const mod of modules) {
      const record = chapters?.[mod.module_no];
      if (!record?.is_completed) {
        return mod.module_name;
      }
    }
    return modules[modules.length - 1]?.module_name || "";
  }, [modules, chapters]);

  return (
    <ILEARNModulesContainer>
      {modules?.map((module, index) => {
        const locked = isModuleLocked(module.module_no);
        const completed = chapters[module.module_no]?.is_completed;
        const isFirst = index === 0;
        const isLast = index === modules.length - 1;
        return (
          <ModuleSection key={module.module_no} $isFirst={isFirst} $isLast={isLast}>
            {locked && <DisabledOverlay />}
            <ModuleTable colors={colors} $isFirst={isFirst} $isLast={isLast}>
              <tbody>
                <ModuleRow>
                  <td colSpan="2">
                    <ModuleHeader colors={colors}>
                      {module.module_name}
                    </ModuleHeader>
                  </td>
                </ModuleRow>
                <ModuleRow>
                  <ModuleDescriptionCell>
                    {completed == 1 && (
                      <CompleteImageStyled
                        src={CompleteImage}
                        alt="Completed"
                      />
                    )}
                    <ModuleDescriptionText>
                      {module.description ||
                        "Thank you for choosing to teach ISAFE lessons..."}
                    </ModuleDescriptionText>
                  </ModuleDescriptionCell>
                  <ImageCell>
                    <ModuleImage
                      src={module.image}
                      alt={module.module_name}
                    />
                  </ImageCell>
                </ModuleRow>
                <ModuleRow>
                  <td colSpan="2">
                    {locked ? (
                      <LockedMessage>
                        Please complete{" "}
                        {currentModuleName || "this module"}
                        .
                      </LockedMessage>
                    ) : (
                      <UnlockButton
                        colors={colors}
                        onClick={() =>
                          navigate(navigation_link[module.module_no])
                        }
                      >
                        {completed ? "Completed" : "Click to Start"}
                      </UnlockButton>
                    )}
                  </td>
                </ModuleRow>
              </tbody>
            </ModuleTable>
          </ModuleSection>
        );
      })}
    </ILEARNModulesContainer>
  );
};

export default ILEARNModulesPage;
